import { Component, ElementRef, Optional, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { ConsultarListaNegraRequest, ImportarChoferRequest, itemsImportarChofer, ListarChoferRequest, TransaccionChoferRequest, TransaccionListaNegraRequest, ValidarDocIdentidadRequest } from '../../../domain/request/mantenimiento-request';
import { ComercialRepository } from 'src/app/repositorio/comercial.repository';
import { StorageService } from 'src/app/services/storage.service';
import { UtilService } from 'src/app/services/util.service';
import { Parametros } from 'src/app/services/domain/services-domain';
import { ConfirmationService, MessageService } from 'primeng/api';
import * as XLSX from 'xlsx-js-style';
import { sunatDniRequest, sunatRequest } from 'src/app/proforma/domain/request/proforma_request';
import { ProformaRepository } from 'src/app/proforma/domain/proforma.repository';
import { firstValueFrom } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-mantenimiento-chofer',
  templateUrl: './mantenimiento-chofer.component.html',
  styleUrl: './mantenimiento-chofer.component.css',
  providers: [MessageService]
})
export class MantenimientoChoferComponent {
  @ViewChild('fileInput') fileInput: ElementRef
  constructor(private readonly mantcomercial: ComercialRepository, private readonly storage: StorageService,
    private util: UtilService, private messageService: MessageService, private confirmationService: ConfirmationService,
    private readonly proformaService: ProformaRepository,
    @Optional() public config: DynamicDialogConfig,
    @Optional() public ref: DynamicDialogRef
  ) { }
  visible: boolean
  visiblebtn: boolean = false
  visibleImport: boolean
  visibleObsr: boolean
  codigo: number
  dato1 = 0
  condata: boolean = false
  selectedFileName: string = '';
  listEmpresa: any[] = []
  listSucursal: any[] = []
  ListaTodosTipoDoc: any[] = []
  ListaTodosTipoBlo: any[] = []
  excelData: any[] = [];
  group: FormGroup
  groupPoppup: FormGroup
  groupPoppupObs: FormGroup
  dataTable: any[] = []
  dataTableImport: any[] = []
  listaImportada: any[] = [];
  ListaTemp: any[] = []
  ListaContenedorExcel: itemsImportarChofer[] = [];
  ItemsExcel: itemsImportarChofer;
  ListaContenedorTemporal: itemsImportarChofer[] = [];
  data: any;
  visibleSoloNuevo: boolean = false
  metadataTable: newmetadate[] = [
    { field: 'spcH_Codigo', title: 'Código', inputType: 'text' }, { field: 'tipoDocumento', title: 'Tipo Documento', inputType: 'text' },
    { field: 'spcH_DocIden', title: 'N° Documento', inputType: 'text' }, { field: 'spcH_Nombres', title: 'Nombres', inputType: 'text' },
    { field: 'spcH_Apellidos', title: 'Apellidos', inputType: 'text' }, { field: 'spcH_RazonSocial', title: 'Razón Social', inputType: 'text' },
    { field: 'spcH_Brevete', title: 'Brevete', inputType: 'text' },//{ field: 'spcH_Activo', title: 'Estado', inputType: 'checkbox' }
    { field: 'spcH_Bloqueado', title: 'Bloqueado', inputType: 'checkbox' }
  ]

  metadataTableImport: newmetadate[] = [
    { field: 'tipo_documento_des', title: 'Tipo Documento', inputType: 'text' }, { field: 'numero_documento', title: 'N° Documento', inputType: 'text' },
    { field: 'nombres_chofer', title: 'Nombres Chofer', inputType: 'text' }, { field: 'apellidos', title: 'Apellidos', inputType: 'text' },
    { field: 'razon_social', title: 'Razón Social', inputType: 'text' },
    { field: 'brevete', title: 'Brevete', inputType: 'text' },//, { field: 'bloqueado', title: 'Bloqueado', inputType: 'text' },
    // { field: 'empresa', title: 'Empresa', inputType: 'text' }, { field: 'sucursal', title: 'Sucursal', inputType: 'text' }
    {
      field: 'observacion', title: ' ', inputType: 'icono', iconI: (row: any) => row.conObservacion === true ? 'pi pi-eye' : 'pi pi-check-circle',
      pTooltip: (row: any) => row.conObservacion === true ? row.observacion : 'Sin Observación', toolTipPosition: 'left',
      colorIcon: (row: any) => row.conObservacion === true ? 'red' : 'green'
    }
  ]

  iniciarFormulario() {
    this.group = new FormGroup({
      numerodoc: new FormControl(null, null), nombreschofer: new FormControl(null, null),
      brevete: new FormControl(null, null), razonsocial: new FormControl(null, null),
      tipodocumento: new FormControl('001', null)
    })
    this.groupPoppup = new FormGroup({
      tipodocumento: new FormControl(null, Validators.required), numerodoc: new FormControl(null, Validators.required),
      nombreschofer: new FormControl(null, Validators.required), brevete: new FormControl(null, Validators.required),
      apellidochofer: new FormControl(null, Validators.required), razonsocial: new FormControl(null, Validators.required)
      // , empresa: new FormControl(null, null),sucursal: new FormControl(null, null)
    })
    this.groupPoppupObs = new FormGroup({
      tipobloqueo: new FormControl(null, Validators.required), observaciones: new FormControl(null, Validators.required),
    })
  }

  parametros: Parametros[] = []
  ListarParametros() {
    this.listEmpresa = this.parametros.slice().filter(r => r.tipo === 'EMPRESA')
    this.listSucursal = this.parametros.slice().filter(r => r.tipo === 'SUCURSAL')
    this.ListaTodosTipoDoc = this.parametros.slice().filter(r => r.tipo === 'TIPODOC' && (r.codigo === '001' || r.codigo === '002'))

    this.ListaTodosTipoBlo = this.parametros.slice().filter(r => r.tipo === 'TBLOQUEO')
  }

  async ngOnInit(): Promise<void> {
    this.data = this.config?.data;
    const loadingScreen = this.util.showLoadingScreen({ message: "Cargando Datos..." })
    this.iniciarFormulario()

    // para recepcionar datos de otro componente
    console.log("data chofer", this.data)
    if (this.data?.modo === 'solo-nuevo') {
      this.visibleSoloNuevo = true;
      this.nuevo()
    }

    this.parametros = await this.util.getParametros()
    this.ListarParametros()
    this.group.get('numerodoc')?.valueChanges.subscribe(value => {
      if (this.numericob === true && value !== null) {
        const filtrado = value.replace(/\D/g, '');
        if (filtrado !== value) {
          this.group.get('numerodoc')?.setValue(filtrado, { emitEvent: false });
        }
      }
    });
    this.groupPoppup.get('numerodoc')?.valueChanges.subscribe(value => {
      if (this.numerico === true && value !== null) {
        const filtrado = value.replace(/\D/g, '');
        if (filtrado !== value) {
          this.groupPoppup.get('numerodoc')?.setValue(filtrado, { emitEvent: false });
        }
      }
    });
    loadingScreen.close()
  }

  async buscar() {
    this.dataTable = []
    this.dataTable = await this.search()
  }

  async search(): Promise<any[]> {
    const values = this.group.value;
    const values2 = this.groupPoppup.value;
    const requestListar: ListarChoferRequest = {
      SPCH_DocIden: (values.numerodoc === '' ? null : values.numerodoc) === null ? values2.numerodoc : values.numerodoc,
      SPCH_Nombres: values.nombreschofer === '' ? null : values.nombreschofer,
      SPCH_RazonSocial: values.razonsocial === '' ? null : values.razonsocial,
      SPCH_Brevete: values.brevete === '' ? null : values.brevete,
      TIPO_CodTDI: (values.tipodocumento === '' ? null : values.tipodocumento) === null ? values2.tipodocumento : values.tipodocumento,
    };

    try {
      const response = await firstValueFrom(this.mantcomercial.ListarChofer(requestListar));
      if (response.datos.status === 200) {
        return response.datos.result;
      } else {
        console.error("⚠️ Backend respondió con error:", response.datos);
        return [];
      }
    } catch (error) {
      console.error("❌ Error en ListarChofer:", error);
      return [];
    }
  }

  nuevo() {
    this.visible = true
    this.visiblebtn = true
    this.codigo = null
    this.groupPoppup.reset()
  }

  editChofer(row) {
    this.visible = true
    this.visiblebtn = false
    this.codigo = row.spcH_Codigo
    this.groupPoppup.reset()
    if (row) {
      if (row.spcH_DocIden) { this.groupPoppup.get('numerodoc').setValue(row.spcH_DocIden) }
      if (row.spcH_Nombres != null) {
        this.natural = true;
        this.groupPoppup.get('nombreschofer').setValue(row.spcH_Nombres)
      }
      if (row.spcH_Apellidos) { this.groupPoppup.get('apellidochofer').setValue(row.spcH_Apellidos) }
      if (row.spcH_Brevete) { this.groupPoppup.get('brevete').setValue(row.spcH_Brevete) }
      if (row.spcH_Motivo) { this.groupPoppup.get('motivo').setValue(row.spcH_Motivo) }
      if (row.spcH_RazonSocial != null) {
        this.natural = false;
        this.groupPoppup.get('razonsocial').setValue(row.spcH_RazonSocial)
      }
      // if (row.empR_Codigo) {
      //   const e = this.listEmpresa.find(r => r.codigo === row.empR_Codigo.toString())?.codigo
      //   this.groupPoppup.get('empresa').setValue(e);
      // }
      // if (row.sucR_Codigo) {
      //   const s = this.listSucursal.find(r => r.codigo === row.sucR_Codigo.toString())?.codigo
      //   this.groupPoppup.get('sucursal').setValue(s);
      // }
      if (row.tipO_CodTDI) {
        const s = this.ListaTodosTipoDoc.find(r => r.codigo === row.tipO_CodTDI.toString())?.codigo
        this.groupPoppup.get('tipodocumento').setValue(s);
      }
    }
  }

  salir() {
    this.visible = false
    this.groupPoppup.reset()
    if (this.visibleSoloNuevo == true) {
      this.enviarComponentePadre({ mensaje: "Cerrar" });
    }
  }

  async TransaccionChofer(tipo, row) {
    if (tipo === 'D') {
      this.confirmationService.confirm({
        target: event.target,
        message: "¿ESTÁ SEGURO QUE DESEA CONTINUAR?",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          const requestTransaccion = <TransaccionChoferRequest>{}
          requestTransaccion.SPCH_Codigo = row?.spcH_Codigo != null ? row.spcH_Codigo : this.codigo
          requestTransaccion.AUDI_Usuario = this.storage.get('usuario')
          requestTransaccion.transaccion = tipo
          this.mantcomercial.TransaccionChofer(requestTransaccion).subscribe((response) => {
            if (response.datos.status === 200) {
              this.util.ShowMessage({ titulo: '', mensaje: 'Se desactivó chofer correctamente.', tipo: 'ok' })
              this.buscar()
              this.visible = false
            }
          })
        },
        reject: () => {
        }
      })
    } else if (tipo === 'B') {
      this.groupPoppupObs.markAllAsTouched();
      const errorMessage: string[] = [];
      const validateFormGroup = (formGroup: FormGroup, groupName: string) => {
        Object.entries(formGroup.controls).forEach(([controlName, control]) => {
          if (control.invalid && control.errors?.['required']) {
            errorMessage.push(`El campo "${controlName}" en "${groupName}" es obligatorio.`);
          }
        });
      };

      validateFormGroup(this.groupPoppupObs, 'Observaciones');
      if (errorMessage.length > 0) {
        return
      }
      this.confirmationService.confirm({
        target: event.target,
        message: "¿ESTÁ SEGURO QUE DESEA CONTINUAR?",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          const values = this.groupPoppupObs.value
          const requestObservcion = <TransaccionListaNegraRequest>{}
          requestObservcion.SPLN_Tipo = 'C'
          requestObservcion.SPLN_Value = this.codigo
          requestObservcion.TIPO_TabBLO = 'BLO'
          requestObservcion.TIPO_CodBLO = values['tipobloqueo']
          requestObservcion.SPLN_Observaciones = values['observaciones']
          requestObservcion.SPLN_Activo = true
          requestObservcion.AUDI_Usuario = this.storage.get('usuario')
          requestObservcion.tipotransaccion = tipo
          this.mantcomercial.TransaccionListaNegra(requestObservcion).subscribe((response) => {
            if (response.datos.status === 200) {
            }
          })
          const requestTransaccion = <TransaccionChoferRequest>{}
          requestTransaccion.SPCH_Codigo = this.codigo
          requestTransaccion.AUDI_Usuario = this.storage.get('usuario')
          requestTransaccion.transaccion = tipo
          this.mantcomercial.TransaccionChofer(requestTransaccion).subscribe((response) => {
            if (response.datos.status === 200) {
              this.util.ShowMessage({ titulo: '', mensaje: 'Se bloqueó chofer correctamente.', tipo: 'ok' })
              this.buscar()
              this.visibleObsr = false
            }
          })
        },
        reject: () => {
        }
      })
    } else {
      this.groupPoppup.markAllAsTouched();
      const errorMessage: string[] = [];
      const tipodoc = this.groupPoppup.value['tipodocumento']
      let event: { originalEvent: PointerEvent, value: string } = { originalEvent: new PointerEvent("click"), value: tipodoc }
      this.CambiarModo(event)
      const validateFormGroup = (formGroup: FormGroup, groupName: string) => {
        Object.entries(formGroup.controls).forEach(([controlName, control]) => {
          if (control.invalid && control.errors?.['required']) {
            errorMessage.push(`El campo "${controlName}" en "${groupName}" es obligatorio.`);
          }
        });
      };

      validateFormGroup(this.groupPoppup, 'Poppup');
      if (errorMessage.length > 0) {
        return
      }
      const arreglo = await this.search();
      console.log(arreglo);
      if (arreglo.length > 0 && tipo === 'I') {
        this.codigo = arreglo[0].spcH_Codigo
        this.visiblebtn = false
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Registro Existente', detail: 'El chofer ya se encuentra registrado.', sticky: true });
        this.groupPoppup.get('brevete').setValue(arreglo[0].spcH_Brevete)
        if (this.groupPoppup.value['tipodocumento'] === '001') {
          this.natural = false
          this.groupPoppup.get('razonsocial').setValue(arreglo[0].spcH_RazonSocial)
        } else {
          this.natural = true
          this.groupPoppup.get('nombreschofer').setValue(arreglo[0].spcH_Nombres)
          this.groupPoppup.get('apellidochofer').setValue(arreglo[0].spcH_Apellidos)
        }
      } else {
        const values = this.groupPoppup.value
        const requestTransaccion = <TransaccionChoferRequest>{}
        requestTransaccion.SPCH_Codigo = row?.spcH_Codigo != null ? row.spcH_Codigo : this.codigo
        requestTransaccion.TIPO_TabTDI = "TDI"
        requestTransaccion.TIPO_CodTDI = values.tipodocumento != null ? values.tipodocumento : row.tipO_CodTDI
        requestTransaccion.SPCH_DocIden = values.numerodoc != null ? values.numerodoc : row.spcH_DocIden
        requestTransaccion.SPCH_Nombres = values.nombreschofer != null ? values.nombreschofer : row.spcH_Nombres
        requestTransaccion.SPCH_Apellidos = values.apellidochofer != null ? values.apellidochofer : row.spcH_Apellidos
        requestTransaccion.SPCH_RazonSocial = values.razonsocial != null ? values.razonsocial : row.spcH_RazonSocial
        requestTransaccion.SPCH_Brevete = values.brevete != null ? values.brevete : row.spcH_Brevete
        requestTransaccion.SPCH_Activo = true
        requestTransaccion.SPCH_Bloqueado = false
        requestTransaccion.AUDI_Usuario = this.storage.get('usuario')
        requestTransaccion.EMPR_Codigo = 1
        requestTransaccion.SUCR_Codigo = 1
        requestTransaccion.transaccion = tipo
        this.mantcomercial.TransaccionChofer(requestTransaccion).subscribe((response) => {
          if (response.datos.status === 200) {
            if (this.visibleSoloNuevo == true) {
              this.enviarComponentePadre({ mensaje: "OK", nuevo_codigo: response.datos.codigo });
              return;
            }
            this.util.ShowMessage({ titulo: '', mensaje: 'Se guardaron los datos correctamente.', tipo: 'ok' })
            this.groupPoppup.reset(this.iniciarFormulario())
            this.buscar()
            this.visible = false
          }
        })
      }
    }
  }

  importExcel() {
    this.visibleImport = true
    this.listaImportada = []
    this.dataTableImport = []
    this.ListaTemp = []
    this.disabledSave = false
  }

  disabledSave: boolean = false
  onFileChange(event: any): void {
    const loadingScreen = this.util.showLoadingScreen({ message: "Importando Datos..." })
    this.dato1 = 1
    this.excelData = []
    this.selectedFileName = ''
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = async (e: any) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        let newExcelData = []
        newExcelData = XLSX.utils.sheet_to_json(worksheet, { raw: false });

        const cabecerasprincipales = []
        this.metadataTableImport.forEach(r => {
          let dato = ''
          dato = r.field.toString()
          cabecerasprincipales.push(dato)
        })


        function procesarObjeto(objetoOriginal: Record<string, any>): Record<string, any> {
          const objetoModificado: Record<string, any> = {};
          for (const clave in objetoOriginal) {
            const claveMinusc = clave.toLowerCase();
            const claveSinTildes = claveMinusc.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            const letras = claveSinTildes.replace(/[().''/]/g, '');
            const claveConGuiones = letras.replace(/\s/g, '_');
            objetoModificado[claveConGuiones] = objetoOriginal[clave];
          }
          return objetoModificado;
        }
        const arrayModificado = newExcelData.map(procesarObjeto);
        const arrayDeCabeceras = arrayModificado.length > 2
          ? Object.keys(arrayModificado[2])
          : Object.keys(arrayModificado[0]);
        console.log(arrayDeCabeceras);
        const ListaImportacion = [];
        for (const row of arrayModificado) {
          const documentoCode = row['tipo_documento']?.trim() !== '' ? this.obtenerDatos(row['tipo_documento']?.trim(), 'TIPODOCUMENTO') : null;
          console.log('DOCUMENTO', documentoCode);
          const requestListarBD: ListarChoferRequest = {
            SPCH_DocIden: row['numero_documento']?.trim(),
            SPCH_Nombres: row['nombres_chofer']?.trim(),
            SPCH_Brevete: row['brevete']?.trim(),
            SPCH_RazonSocial: row['razon_social']?.trim(),
            TIPO_CodTDI: documentoCode
          };
          const requestListarRUC: sunatRequest = {
            razonsocial: row['razon_social']?.trim(),
            ruc: row['numero_documento']?.trim()
          }

          const requestListarDNI: sunatDniRequest = {
            token: null,
            dni: row['numero_documento']?.trim()
          }
          let mensajebd = null
          let existebd = false;
          try {
            const response = await firstValueFrom(this.mantcomercial.ListarChofer(requestListarBD));
            existebd = response?.datos?.result?.length > 0;
            mensajebd = existebd === true ? 'El chofer ya se encuentra registrado' : null
          } catch (err) {
            console.error(`Error al validar chofer ${row['nombres_chofer'] ?? row['razon_social']}:`, err);
          }
          let existeruc = false;
          let mensajeruc = null
          try {
            const response = await firstValueFrom(this.proformaService.listarSunat(requestListarRUC));
            existeruc = response?.datos?.result?.length > 0;
            const razonSocialLimpia = response?.datos?.result[0].nombre_o_razon_social.replace(/\\/g, '').trim();
            const razonSunat = (razonSocialLimpia || '')?.toLowerCase()?.trim();
            const razonExcel = (row['razon_social'] || '').toLowerCase()?.trim();
            const camposFaltantes: string[] = [];
            if (row['razon_social'] === null || row['razon_social'] === undefined || row['razon_social'].toString().trim() === "") {
              camposFaltantes.push('nombres');
            }
            if (row['brevete'] === null || row['brevete'] === undefined || row['brevete'].toString().trim() === "") {
              camposFaltantes.push('brevete');
            }
            const faltanCampos = camposFaltantes.length > 0;
            const formatearCampos = (lista: string[]) => {
              if (lista.length === 1) return lista[0];
              if (lista.length === 2) return lista.join(' y ');
              return `${lista.slice(0, -1).join(', ')} y ${lista[lista.length - 1]}`;
            };
            mensajeruc = faltanCampos === false ? (razonSunat.includes(razonExcel) || razonExcel.includes(razonSunat) ? null : 'Los datos de RUC no coinciden con SUNAT') : `No se importó ${formatearCampos(camposFaltantes)} para este RUC`
          } catch (err) {
            console.error(`Error al validar chofer ${row['razon_social']}:`, err);
            mensajeruc = 'RUC no encontrado en SUNAT'
          }
          let existedni = false;
          let mensajedni = null
          try {
            const response = await firstValueFrom(this.proformaService.listarSunatDni(requestListarDNI));
            existedni = response?.datos?.result?.length > 0;
            const nombreReniec = (response?.datos?.result[0].nombre_completo || '')?.toLowerCase()?.trim();
            console.log('nombreReniec', nombreReniec)
            const nombreExcel = (`${row['apellidos']} ${row['nombres_chofer']}` || '')?.toLowerCase()?.trim();
            console.log('nombreExcel', nombreExcel)
            const camposFaltantes: string[] = [];
            if (row['nombres_chofer'] === null || row['nombres_chofer'] === undefined || row['nombres_chofer'].toString().trim() === "") {
              camposFaltantes.push('nombres');
            }
            if (row['apellidos'] === null || row['apellidos'] === undefined || row['apellidos'].toString().trim() === "") {
              camposFaltantes.push('apellidos');
            }
            if (row['brevete'] === null || row['brevete'] === undefined || row['brevete'].toString().trim() === "") {
              camposFaltantes.push('brevete');
            }
            const faltanCampos = camposFaltantes.length > 0;
            const formatearCampos = (lista: string[]) => {
              if (lista.length === 1) return lista[0];
              if (lista.length === 2) return lista.join(' y ');
              return `${lista.slice(0, -1).join(', ')} y ${lista[lista.length - 1]}`;
            };
            mensajedni = faltanCampos === true ? `No se importó ${formatearCampos(camposFaltantes)} para este DNI` : (nombreReniec.includes(nombreExcel) || nombreExcel.includes(nombreReniec) ? null : 'Los datos de DNI no coinciden con RENIEC')
          } catch (err) {
            console.error(`Error al validar chofer ${row['nombres_chofer']}:`, err);
            mensajedni = 'DNI no encontrado en RENIEC'
          }
          let observacion = existebd === true ? mensajebd : (documentoCode === '002' ? mensajedni : mensajeruc)
          ListaImportacion.push({
            tipo_documento: documentoCode,
            tipo_documento_des: row['tipo_documento'],
            numero_documento: row['numero_documento']?.trim(),
            nombres_chofer: row['nombres_chofer']?.trim(),
            apellidos: row['apellidos']?.trim(),
            razon_social: row['razon_social']?.trim(),
            brevete: row['brevete']?.trim(),
            bloqueado: false,
            empresa: 1,
            sucursal: 1,
            conObservacion: observacion === null ? false : true,
            observacion: observacion
          });
        }
        this.listaImportada = [...this.listaImportada, ...ListaImportacion]
        this.dataTableImport = [...this.dataTableImport, ...ListaImportacion]
        console.log('LISTA IMPORTADA', this.listaImportada);
        this.condata = true
        if (this.fileInput) {
          this.fileInput.nativeElement.value = null;
        }
        this.disabledSave = this.listaImportada?.some(item => item.conObservacion === true);
        loadingScreen.close()
      } catch (error) {
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Warn', detail: 'Hubo un error en la importación.', sticky: true });
        console.error('Error al procesar el archivo Excel:', error);
        loadingScreen.close()
      } finally {
        this.dato1 = 0
      }
    };

    reader.readAsArrayBuffer(file);
  }

  obtenerDatos(campo: string, tipo: string): string {
    let result
    if (tipo === 'EMPRESA') {
      result = this.listEmpresa.find(item => item.nombre.toUpperCase() === campo.toUpperCase())?.codigo
      return result
    } else if (tipo === 'SUCURSAL') {
      result = this.listSucursal.find(item => item.nombre.toUpperCase() === campo.toUpperCase())?.codigo
      return result
    } else {
      result = this.ListaTodosTipoDoc.find(item => item.nombre.toUpperCase() === campo.toUpperCase())?.codigo
      return result
    }

  }

  selectFile() {
    document.getElementById('fileInput')?.click();
  }

  guardarExcel() {
    if (this.listaImportada.length == 0) {
      this.util.showMessage("Ingrese la información a guardar")
    } else {
      this.dato1 = 1
      let contador: number = 0
      let contadorgeneral: number = 0
      this.ListaContenedorExcel = []
      let j = 0
      this.listaImportada.forEach(element => {
        contador++
        contadorgeneral++
        this.ItemsExcel = <itemsImportarChofer>{}
        this.ItemsExcel.TIPO_TabTDI = "TDI"
        this.ItemsExcel.TIPO_CodTDI = element.tipo_documento
        this.ItemsExcel.SPCH_DocIden = element.numero_documento
        this.ItemsExcel.SPCH_Nombres = element.nombres_chofer
        this.ItemsExcel.SPCH_Apellidos = element.apellidos
        this.ItemsExcel.SPCH_RazonSocial = element.razon_social
        this.ItemsExcel.SPCH_Brevete = element.brevete
        this.ItemsExcel.SPCH_Activo = true
        this.ItemsExcel.SPCH_Bloqueado = element.bloqueado
        this.ItemsExcel.AUDI_Usuario = this.storage.get('usuario')
        this.ItemsExcel.EMPR_Codigo = element.empresa
        this.ItemsExcel.SUCR_Codigo = element.sucursal

        this.ListaContenedorExcel.push(this.ItemsExcel)

      });

      this.ListaContenedorExcel
      const tamañoLote = 20000;
      const cantidadLotes = Math.ceil(this.listaImportada.length / tamañoLote);

      for (let i = 0; i < cantidadLotes; i++) {
        const inicio = i * tamañoLote;
        const fin = (i + 1) * tamañoLote;
        const lote = this.ListaContenedorExcel.slice(inicio, fin);
        const Requestimport: ImportarChoferRequest = {
          tabladetallechofer: lote
        };

        this.mantcomercial.ImportarChofer(Requestimport).subscribe(response => {
          if (response.datos.status === 200) {
            contador = 0
            this.ListaContenedorExcel = []
            this.util.NuevoMensaje('DATOS GUARDADOS', this.dataTableImport.length + ' Registros', 'check', null, false)
            this.visibleImport = false
            this.dataTableImport = []
            this.ListaTemp = []
            this.listaImportada = []
            this.buscar()
          }

        }, (errorServicio) => {
          this.util.NuevoMensaje('ERROR', (errorServicio.error.meta.mensaje).toUpperCase(), 'clear', null, false)

        })
      }
      this.dato1 = 0
    }
  }

  salirImportar() {
    this.visibleImport = false
  }
  natural: boolean = true
  async validarDocumento() {
    const arreglo = await this.search();
    if (arreglo.length > 0) {
      this.codigo = arreglo[0].spcH_Codigo
      this.visiblebtn = false
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Registro Existente', detail: 'El chofer ya se encuentra registrado.', sticky: true });
      this.groupPoppup.get('brevete').setValue(arreglo[0].spcH_Brevete)
      if (this.groupPoppup.value['tipodocumento'] === '001') {
        this.natural = false
        this.groupPoppup.get('razonsocial').setValue(arreglo[0].spcH_RazonSocial)
      } else {
        this.natural = true
        this.groupPoppup.get('nombreschofer').setValue(arreglo[0].spcH_Nombres)
        this.groupPoppup.get('apellidochofer').setValue(arreglo[0].spcH_Apellidos)
      }
    } else {
      const values = this.groupPoppup.value
      if (values['tipodocumento'] === '001') {
        this.natural = false
        const sunatRUC = await this.validarRuc();
        if (sunatRUC.length > 0) {
          const razonSocialLimpia = sunatRUC[0].nombre_o_razon_social.replace(/\\/g, '').trim();
          this.groupPoppup.get('razonsocial').setValue(razonSocialLimpia)
          this.messageService.clear();
          this.messageService.add({ severity: 'success', summary: 'Documento encontrado', detail: 'El documento de identidad se encuentra registrado en SUNAT.', sticky: true });
        } else {
          this.messageService.clear();
          this.messageService.add({ severity: 'warn', summary: 'No identificado', detail: 'El documento de identidad no se encuentra registrado en SUNAT, por favor verifique.', sticky: true });
        }
      } else {
        const sunatDNI = await this.validarDNI();
        if (sunatDNI.length > 0) {
          const nombreCompleto = sunatDNI[0].nombre_completo?.trim() || '';
          const partes = nombreCompleto.split(/\s+/);
          let nombres = '';
          let apellidos = '';
          switch (partes.length) {
            case 4:
              nombres = partes[0] + ' ' + partes[1];
              apellidos = partes[2] + ' ' + partes[3];
              break;
            case 3:
              nombres = partes[0];
              apellidos = partes[1] + ' ' + partes[2];
              break;
            case 2:
              nombres = partes[0];
              apellidos = partes[1];
              break;
          }
          this.groupPoppup.get('nombreschofer').setValue(nombres)
          this.groupPoppup.get('apellidochofer').setValue(apellidos)
          this.messageService.clear();
          this.messageService.add({ severity: 'success', summary: 'Documento encontrado', detail: 'El documento de identidad se encuentra registrado en SUNAT.', sticky: true });
        } else {
          this.messageService.clear();
          this.messageService.add({ severity: 'warn', summary: 'No identificado', detail: 'El documento de identidad no se encuentra registrado en SUNAT, por favor verifique.', sticky: true });
        }
        this.natural = true
      }
    }
  }
  naturalb: boolean = false
  numerico: boolean
  CambiarModo(event) {
    // this.groupPoppup.get('numerodoc')?.reset();
    console.log(event)
    if (event.value === '001') {
      this.natural = false;
      this.numerico = true
      this.groupPoppup.get('razonsocial')?.setValidators([Validators.required]);
      this.groupPoppup.get('razonsocial')?.updateValueAndValidity();
      this.groupPoppup.get('nombreschofer')?.clearValidators();
      this.groupPoppup.get('apellidochofer')?.clearValidators();
      this.groupPoppup.get('nombreschofer')?.updateValueAndValidity();
      this.groupPoppup.get('apellidochofer')?.updateValueAndValidity();
      this.groupPoppup.get('nombreschofer')?.reset();
      this.groupPoppup.get('apellidochofer')?.reset();
      this.groupPoppup.get('nombreschofer')?.updateValueAndValidity();
      this.groupPoppup.get('apellidochofer')?.updateValueAndValidity();
    } else {
      this.natural = true;
      this.groupPoppup.get('razonsocial')?.clearValidators();
      this.groupPoppup.get('razonsocial')?.updateValueAndValidity();
      this.groupPoppup.get('razonsocial')?.reset();
      this.groupPoppup.get('nombreschofer')?.setValidators([Validators.required]);
      this.groupPoppup.get('nombreschofer')?.updateValueAndValidity();
      this.groupPoppup.get('apellidochofer')?.setValidators([Validators.required]);
      this.groupPoppup.get('apellidochofer')?.updateValueAndValidity();
      if (event.value === '002') {
        this.numerico = true
      } else {
        this.numerico = false
      }
    }
    console.log('numerico', this.numerico)
  }
  numericob: boolean = true
  CambiarModo2(event) {
    this.group.get('numerodoc')?.reset();
    if (event.value === '001') { this.naturalb = false; this.numericob = true } else { this.naturalb = true; if (event.value === '002') { this.numericob = true } else { this.numericob = false } }
    console.log('numericob', this.numericob)
  }
  verObsr: boolean
  abrirObservaciones(row) {
    this.groupPoppupObs.reset()
    this.visibleObsr = true
    this.codigo = row.spcH_Codigo
    if (row.spcH_Bloqueado === true) {
      this.verObsr = true
      const request: ConsultarListaNegraRequest = <ConsultarListaNegraRequest>{}
      request.SPLN_Tipo = "C"
      request.SPLN_Value = row.spcH_Codigo
      this.mantcomercial.ConsultarListaNegra(request).subscribe(response => {
        if (response.datos.status === 200) {
          this.groupPoppupObs.get('tipobloqueo').setValue(response.datos.result[0].tipO_CodBLO)
          this.groupPoppupObs.get('observaciones').setValue(response.datos.result[0].splN_Observaciones)
        }
      })
    } else {
      this.verObsr = false
    }
  }

  salirBloqueo() {
    this.visibleObsr = false
  }

  desbloquear(row) {
    this.confirmationService.confirm({
      target: event.target,
      message: "¿ESTÁ SEGURO QUE DESEA DESBLOQUEAR CHOFER?",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const requestObservcion = <TransaccionListaNegraRequest>{}
        requestObservcion.SPLN_Tipo = 'C'
        requestObservcion.SPLN_Value = row.spcH_Codigo
        requestObservcion.SPLN_Activo = false
        requestObservcion.AUDI_Usuario = this.storage.get('usuario')
        requestObservcion.tipotransaccion = 'D'
        this.mantcomercial.TransaccionListaNegra(requestObservcion).subscribe((response) => {
          if (response.datos.status === 200) {
          }
        })
        const requestTransaccion = <TransaccionChoferRequest>{}
        requestTransaccion.SPCH_Codigo = row.spcH_Codigo
        requestTransaccion.AUDI_Usuario = this.storage.get('usuario')
        requestTransaccion.transaccion = 'R'
        this.mantcomercial.TransaccionChofer(requestTransaccion).subscribe((response) => {
          if (response.datos.status === 200) {
            this.util.ShowMessage({ titulo: '', mensaje: 'Se desbloqueó chofer correctamente.', tipo: 'ok' })
            this.buscar()
          }
        })
      },
      reject: () => {
      }
    })
  }

  exportExcel() {
    const doc = this.group.value
    let headers
    if (doc.tipodocumento === '002') {
      headers = [
        ["Tipo Documento", "Número Documento", "Nombres Chofer", "Apellidos", "Brevete"]
      ];
    } else {
      headers = [
        ["Tipo Documento", "Número Documento", "Razón Social", "Brevete"]
      ];
    }

    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(headers);
    const workbook: XLSX.WorkBook = { Sheets: { 'Choferes': worksheet }, SheetNames: ['Choferes'] };
    XLSX.writeFile(workbook, 'Choferes.xlsx');
  }

  async validarRuc(): Promise<any[]> {
    const values = this.groupPoppup.value
    const requestSunat: sunatRequest = {
      razonsocial: values["razonSocial"],
      ruc: values["numerodoc"]
    }

    try {
      const response = await firstValueFrom(this.proformaService.listarSunat(requestSunat));
      if (response.datos.status === 200) {
        return response.datos.result;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  }

  async validarDNI(): Promise<any[]> {
    const values = this.groupPoppup.value
    const requestSunat: sunatDniRequest = {
      token: null,
      dni: values["numerodoc"]
    }

    try {
      const response = await firstValueFrom(this.proformaService.listarSunatDni(requestSunat));
      if (response.datos.status === 200) {
        return response.datos.result;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  }

  deleteRow(row) {
    const index1 = this.listaImportada.findIndex(item => item.numero_documento === row.numero_documento);
    if (index1 > -1) {
      this.listaImportada.splice(index1, 1);
    }
    this.listaImportada = [...this.listaImportada]
    const index2 = this.dataTableImport.findIndex(item => item.numero_documento === row.numero_documento);
    if (index2 > -1) {
      this.dataTableImport.splice(index2, 1);
    }
    this.dataTableImport = [...this.dataTableImport]
    this.disabledSave = this.listaImportada?.some(item => item.conObservacion === true);
  }

  enviarComponentePadre(objeto: any) { this.ref.close(objeto); }
}
